import React, { useEffect, useState } from 'react'
import { Grid, Paper, ButtonBase, Dialog, DialogTitle, DialogActions, Typography, Button, CardMedia, DialogContent } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { completeTask } from '../../../api/APIServices';
import { useNavigation } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
  borderRadius: '7px'
});

function Exercise({ exercise }) {
  const dispatch = useDispatch();

  const { t } = useTranslation('global');
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const markAsComplete = (taskId) => {
    dispatch(completeTask({ taskId: taskId }));
    setOpen(false);
  }


  return (
    <Paper
    sx={{
      p: 2,
      margin: '5px',
      width: '100%',
      boxShadow: 0,
      backgroundColor: '#c7d6df'
    }}
  >
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4} display="flex" justifyContent="center">
        <ButtonBase
          onClick={handleClickOpen}
          sx={{
            width: { xs: 100, sm: 128 },
            height: { xs: 100, sm: 128 },
          }}
        >
          <Img
            alt="exercise image"
            src={exercise.levels[0].imageUrl}
            sx={{ maxWidth: '100%', maxHeight: '100%' }}
          />
        </ButtonBase>
      </Grid>
  
      <Grid item xs={12} sm={8} container>
        <Grid container direction="column" spacing={1}>
          <Grid item>
            <Grid container justifyContent="space-between" alignItems="center">
              <Typography gutterBottom variant="subtitle1" component="div">
                {exercise.levels[0].name}
              </Typography>
              {exercise?.levels[0]?.isCompleted && (
                <CheckCircleIcon sx={{ color: 'green' }} />
              )}
            </Grid>
            <Typography variant="body2" gutterBottom>
              {exercise.description}
            </Typography>
          </Grid>
          <Grid item>
            <Button
              size="small"
              type="button"
              variant="outlined"
              onClick={handleClickOpen}
            >
              Play Video
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  
    {/* Responsive Dialog */}
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: '100%',
            minHeight: '400px',
            fontFamily: 'Open Sans',
          },
          "& .MuiDialogContent-root": {
            padding: '10px',
          },
          "& .MuiDialogTitle-root": {
            padding: '10px 5px 0px 10px',
          },
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">
        {exercise?.levels[0]?.name}
      </DialogTitle>
      <DialogContent>
        <CardMedia
          component="video"
          image={exercise?.levels[0]?.videoUrl}
          controls
          sx={{
            width: '100%',
            height: { xs: 200, sm: 300, md: 380 },
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          size="small"
          variant="contained"
          onClick={handleClose}
        >
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  </Paper>
  
  )
}

export default Exercise